// Central content for the Taps Music hub. Swap these placeholders with real content anytime.

export const IMAGES = {
  heroStudio: "/photos/p5.jpg",
  session: "/photos/p4.jpg",
  producer: "/photos/p3.jpg",
  lounge: "/photos/p1.jpg",
  group: "/photos/group.jpg",
  plaqueWall: "/photos/p6.jpg",
  plaquesHold: "/photos/p7.jpg",
  plaquesFlat: "/photos/p2.jpg",
  consoleDetail: "/photos/p4.jpg",
  djBooth: "https://images.unsplash.com/photo-1663668566971-afaa3f07903d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  djCrowd: "https://images.unsplash.com/photo-1574155376612-bfa4ed8aabfd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  djLive: "https://images.pexels.com/photos/6398745/pexels-photo-6398745.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
};

export const NAV = [
  { label: "Work", href: "#work" },
  { label: "About", href: "#about" },
  { label: "Partnership", href: "#partnership" },
  { label: "Sessions", href: "#sessions" },
  { label: "Roadmap", href: "#roadmap" },
  { label: "DJ", href: "#dj" },
  { label: "Community", href: "#community" },
  { label: "Contact", href: "#contact" },
];

export const STATS = [
  { value: "6+", label: "Years producing" },
  { value: "Started @ 16", label: "Self-taught" },
  { value: "London", label: "Weekly sessions" },
  { value: "Diverse", label: "Sound focus" },
];

// Selected work — real collaborations. Presented as credits (no likeness used).
export const CREDITS = [
  { artist: "Nines", note: "Production / Collaboration", tag: "Placement", link: "https://youtu.be/TtZAcQDm-n8" },
  { artist: "Digga D", note: "Production / Collaboration", tag: "Placement", link: "https://youtu.be/sDfzvocCaqI" },
  { artist: "Ché Mario", note: "Production / Collaboration", tag: "Placement", link: "https://youtu.be/uIQtdQ3eees" },
  { artist: "Nemzzz", note: "Production / Collaboration", tag: "Placement", link: "https://youtu.be/wGudTKlWI_0" },
  { artist: "Potter Payper", note: "Production / Collaboration", tag: "Placement", link: "https://youtu.be/TtZAcQDm-n8" },
];

export const CERTS = [
  { cert: "1× Gold", detail: "Gold-certified album", tone: "gold" },
  { cert: "3× Silver", detail: "Silver-certified albums", tone: "silver" },
  { cert: "3× UK #1", detail: "UK Number One albums", tone: "gold" },
  { cert: "30M+", detail: "Streams across the catalogue", tone: "platinum" },
];

export const ABOUT = {
  overline: "About",
  lead: "I started producing at 16. Six years later, it's a profession — and a business.",
  paras: [
    "What started as beats in a bedroom became something real: professional placements, genuine industry relationships, and a proper structure behind the music — publishing, admin and management.",
    "Those years taught me the craft and the business in equal measure. Now I'm building something bigger — an ecosystem where serious artists develop their sound, release with intent and grow with real direction.",
    "I'm not here to sell you a beat and move on. I'm here to help you build a sound, a catalogue and a career that lasts.",
  ],
};

export const SERVICES = [
  "Production",
  "Studio sessions",
  "Sound development",
  "Song feedback",
  "Creative direction",
  "Catalogue planning",
  "Release planning",
  "Long-term creative partnership",
];

export const IDEAL_ARTIST = [
  "Serious about building a career",
  "Release consistently",
  "Have an existing audience",
  "Invest into their career",
  "Want a unique sound",
  "Open to long-term collaboration",
];

export const GENRES = [
  "UK Rap",
  "Trap",
  "Afrobeat",
  "Amapiano",
  "Afrohouse",
  "Alternative R&B",
  "Experimental / Club",
  "Other",
];

export const FUNNEL = [
  "Studio session",
  "Relationship",
  "Multiple records",
  "Artist development",
  "Long-term partnership",
];

export const ECOSYSTEM = [
  { no: "01", title: "Artist Partnerships", role: "The core", body: "Working closely with a select few artists." },
  { no: "02", title: "Skool Community", role: "The collective", body: "808s & Assets — a home for producers." },
  { no: "03", title: "DJ / Performance", role: "The stage", body: "Taking the sound to the crowd." },
  { no: "04", title: "Publishing Catalogue", role: "The legacy", body: "A growing body of work." },
];

export const INTEREST_TYPES = ["Studio Session", "Creative Partnership"];
export const YES_NO = ["Yes", "No", "Not yet"];

export const SOCIALS = [
  { label: "Instagram", href: "https://www.instagram.com/tapssmusic" },
  { label: "TikTok", href: "https://www.tiktok.com/@tapssmusic" },
  { label: "YouTube", href: "https://www.youtube.com/@tapssmusic" },
  { label: "X", href: "https://x.com/prodbytaps" },
  { label: "Facebook", href: "https://www.facebook.com/TAPSSMUSIC" },
  { label: "Snapchat", href: "https://www.snapchat.com/@tapsldn" },
];

export const SKOOL_URL = "https://www.skool.com/808s-assets-7640/about";
export const SKOOL_NAME = "808s & Assets";
export const CONTACT_EMAIL = "prodbytapsmgmt@gmail.com";

export const CAL_URL = "https://cal.com/tapss-ggkozt/30min";
export const BEACONS_URL = "https://beacons.ai/tapssmusic?utm_source=ig&utm_medium=social&utm_content=link_in_bio&fbclid=PAZXh0bgNhZW0CMTEAc3J0YwZhcHBfaWQPOTM2NjE5NzQzMzkyNDU5AAGnVo8EgoFgXElKDRJCmODzK3pqniYpEZE5XBt8DXIpwTMvQnZWMNMwLBCcfTc_aem_9HjHvPAI05Kj-q-YdV2o9g";

export const SPOTIFY_PLAYLIST_ID = "3nHTAGcEnzV1ewPt2xaDNr";
export const SPOTIFY_PLAYLIST_URL = "https://open.spotify.com/playlist/3nHTAGcEnzV1ewPt2xaDNr";
